import React from "react";

const EmptyBox2 = props => {
    const { fill, classname } = props;

    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill={ fill } className={ classname !== undefined ? classname : "" }>
            <path d="m23.908 12.331-3.963-8.587c-.489-1.059-1.558-1.744-2.725-1.744h-10.44c-1.167 0-2.236.685-2.724 1.743l-3.964 8.588c-.061.131-.092.274-.092.419v6.25c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3v-6.25c0-.145-.031-.288-.092-.419zm-18.036-7.75c.163-.353.519-.581.908-.581h10.44c.389 0 .745.228.908.581l3.424 7.419h-2.059c-.778 0-1.452.501-1.676 1.247l-1.073 3.575c-.031.106-.127.178-.238.178h-9.012c-.111 0-.207-.072-.239-.179l-1.073-3.574c-.224-.746-.897-1.247-1.676-1.247h-2.058z"></path>
        </svg>
    );
}

export default EmptyBox2;
